import { __awaiter, __generator } from "tslib";
import { BrowserAuthError, InteractionRequiredAuthError } from '@azure/msal-browser';
import { getAccount, getMsalClient, authenticate, signOut } from '../../uip';
import { getWebStoreApiConfig } from '../config/actions';
import { getAuthToken, getGuestToken, validateJWTToken } from '../utilities';
import { tokenValidationInterval } from '../constants';
import { buildB2cPolicies } from '../../uip/config/actions';
import { fetchAuthorizationSetting } from '../../../api/site-settings';
var WebStoreApiClient = /** @class */ (function () {
    function WebStoreApiClient() {
        var _this = this;
        this.validate = function () { return __awaiter(_this, void 0, void 0, function () {
            var storageKey, token;
            return __generator(this, function (_a) {
                storageKey = this.account ? "web-store-auth-token" /* WebStoreAuthToken */ : "web-store-guest-token" /* WebStoreGuestToken */;
                token = this.storage.getItem(storageKey);
                if (!token) {
                    return [2 /*return*/, (this.onTokenAcquired = this.ensure())];
                }
                if (!validateJWTToken(token)) {
                    this.resetWorker();
                    return [2 /*return*/, (this.onTokenAcquired = this.ensure())];
                }
                return [2 /*return*/, token];
            });
        }); };
        this.handleResponse = function (response) { return __awaiter(_this, void 0, void 0, function () {
            var request, accessToken, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!(response === null)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.ensure()];
                    case 1: return [2 /*return*/, _c.sent()];
                    case 2:
                        request = this.getSilentRequest(response.account || undefined);
                        return [4 /*yield*/, this.acquireToken(request)];
                    case 3:
                        accessToken = _c.sent();
                        _a = getAuthToken;
                        _b = [accessToken || ''];
                        return [4 /*yield*/, getGuestToken()];
                    case 4: return [4 /*yield*/, _a.apply(void 0, _b.concat([_c.sent()]))];
                    case 5: return [2 /*return*/, _c.sent()];
                }
            });
        }); };
        this.workerId = this.registerWorker();
        this.msalClient = getMsalClient();
        this.onTokenAcquired = this.msalClient.handleRedirectPromise()
            .then(this.handleResponse);
    }
    Object.defineProperty(WebStoreApiClient.prototype, "account", {
        get: function () {
            return getAccount();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WebStoreApiClient.prototype, "isAuthorized", {
        get: function () {
            return !!this.account;
        },
        enumerable: false,
        configurable: true
    });
    WebStoreApiClient.prototype.signIn = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, marketLocale, scopes, signInRequest;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = getWebStoreApiConfig(), marketLocale = _a.marketLocale, scopes = _a.scopes;
                        signInRequest = { extraQueryParameters: { ui_locales: marketLocale }, scopes: scopes };
                        return [4 /*yield*/, authenticate(signInRequest)];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    WebStoreApiClient.prototype.signOut = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.account) {
                            return [2 /*return*/];
                        }
                        this.storage.removeItem("web-store-auth-token" /* WebStoreAuthToken */);
                        this.storage.removeItem("customer-auth-id" /* CustomerAuthId */);
                        return [4 /*yield*/, signOut(this.account)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    WebStoreApiClient.prototype.signUp = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, marketLocale, scopes, settings, authorities, signUpRequest;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = getWebStoreApiConfig(), marketLocale = _a.marketLocale, scopes = _a.scopes;
                        return [4 /*yield*/, fetchAuthorizationSetting()];
                    case 1:
                        settings = _b.sent();
                        if (!settings) {
                            return [2 /*return*/];
                        }
                        authorities = buildB2cPolicies(settings).authorities;
                        signUpRequest = {
                            authority: authorities.signUp.authority,
                            extraQueryParameters: { ui_locales: marketLocale },
                            scopes: scopes
                        };
                        return [4 /*yield*/, authenticate(signUpRequest)];
                    case 2:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    WebStoreApiClient.prototype.acquireToken = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var accessToken, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 7]);
                        return [4 /*yield*/, this.msalClient.acquireTokenSilent(request)];
                    case 1:
                        accessToken = (_a.sent()).accessToken;
                        return [2 /*return*/, accessToken];
                    case 2:
                        error_1 = _a.sent();
                        console.warn(error_1);
                        if (!(error_1 instanceof BrowserAuthError)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.signOut()];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        if (!(error_1 instanceof InteractionRequiredAuthError)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.msalClient.acquireTokenRedirect(request)];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6: return [2 /*return*/, ''];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    WebStoreApiClient.prototype.ensure = function () {
        return __awaiter(this, void 0, void 0, function () {
            var request, accessToken, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!!this.isAuthorized) return [3 /*break*/, 2];
                        return [4 /*yield*/, getGuestToken()];
                    case 1: return [2 /*return*/, _c.sent()];
                    case 2:
                        request = this.getSilentRequest();
                        return [4 /*yield*/, this.acquireToken(request)];
                    case 3:
                        accessToken = _c.sent();
                        _a = getAuthToken;
                        _b = [accessToken];
                        return [4 /*yield*/, getGuestToken()];
                    case 4: return [4 /*yield*/, _a.apply(void 0, _b.concat([_c.sent()]))];
                    case 5: return [2 /*return*/, _c.sent()];
                }
            });
        });
    };
    WebStoreApiClient.prototype.resetWorker = function () {
        this.cancelWorker();
        this.workerId = this.registerWorker();
    };
    WebStoreApiClient.prototype.registerWorker = function () {
        return window.setInterval(this.validate, tokenValidationInterval);
    };
    WebStoreApiClient.prototype.cancelWorker = function () {
        window.clearInterval(this.workerId);
    };
    WebStoreApiClient.prototype.getSilentRequest = function (account) {
        if (account === void 0) { account = this.account; }
        var scopes = getWebStoreApiConfig().scopes;
        return {
            account: account,
            forceRefresh: false,
            scopes: scopes,
        };
    };
    Object.defineProperty(WebStoreApiClient.prototype, "storage", {
        get: function () {
            return getWebStoreApiConfig().storage;
        },
        enumerable: false,
        configurable: true
    });
    return WebStoreApiClient;
}());
/** Singleton */
var webStoreApiClient;
export var getWebStoreApiClient = function () {
    // Check whether it's browser environment or not.
    if (typeof window === undefined) {
        return webStoreApiClient || (webStoreApiClient = new WebStoreApiClient());
    }
    var existingClient = window.WebStoreApiClient;
    if (!existingClient) {
        window.WebStoreApiClient = webStoreApiClient || (webStoreApiClient = new WebStoreApiClient());
    }
    return window.WebStoreApiClient;
};
